import { action, computed, observable } from 'mobx';
import { ISODate } from '../../../../../commonv3/types/dates';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SessionApis } from '../../../../apis/sessions';
import { SessionIndexView, SessionType } from '../../../../types/sessions';
import moment, { Moment } from 'moment-timezone';
import { getLocationFilter, LocationFilter } from '../../../molecules/forms/LocationSelector';
import { Predicates } from '../../../../../commonv3/utils/predicates';

enum LocationType {
    ONLINE = 'online',
    OFFLINE = 'offline',
}

const LIST_OPTIONS = [
    { label: '全て', value: null },
    { label: 'オンライン', value: LocationType.ONLINE },
    { label: 'オフライン', value: LocationType.OFFLINE },
];

export class SessionListState {
    @observable sessionType: SessionType = SessionType.GROUP_COACHING;
    @observable selectedDate: ISODate = null;
    @observable selectedMonth: Moment = null;
    @observable selectedLocationType = null;
    @observable selectedLocationSelectors: LocationFilter[] = [];
    locationTypeOptions = LIST_OPTIONS;
    @observable sessions: RemoteResourceV3<SessionIndexView[]> = RemoteResourceV3.loading();

    @action.bound
    async init() {
        this.reloadSessions();
    }

    @computed
    get sessionListLoading() {
        return this.sessions.loading;
    }

    @action.bound
    async reloadSessions() {
        await updateRemoteResourceV3(this.sessions, (v) => (this.sessions = v), () => SessionApis.findAll());
    }

    @action.bound
    setSessionType(type: SessionType) {
        this.sessionType = type;
        this.setSelectedDate(null);
    }

    @action.bound
    setSelectedDate(date: ISODate) {
        if (this.selectedDate === date) {
            this.selectedDate = null;
        } else {
            this.selectedDate = date;
        }
    }

    @action.bound
    setSelectedMonth(month: Moment) {
        this.selectedMonth = month;
        if (
            !moment(this.selectedDate)
                .startOf('month')
                .isSame(month)
        ) {
            this.selectedDate = null;
        }
    }

    @action.bound
    setSelectedLocationType(locationType: LocationType) {
        this.selectedLocationType = locationType;
    }

    @action.bound
    setSelectedLocationSelectors(locationSelectors: LocationFilter[]) {
        this.selectedLocationSelectors = locationSelectors;
    }

    @computed
    get sessionsOfType() {
        return this.sessions.getOrElse([]).filter((r) => r.session_type === this.sessionType);
    }

    @computed
    get filteredSessions() {
        return this.sessionsOfType
            .filter((r) => !this.selectedMonth || moment(r.starts_at).month() === this.selectedMonth.month())
            .filter((r) => !this.selectedDate || moment(r.starts_at).format('YYYY-MM-DD') === this.selectedDate)
            .filter(Predicates.anyMatch(this.selectedLocationSelectors.map((s) => getLocationFilter(s))));
    }
}
